export default __webpack_public_path__ + "static/media/lockr-logo.964e5517.svg";